module.exports = __webpack_public_path__ + "static/media/select_la_22.5a552060.png";